class DropdownToggle extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (this.hasAttribute('data-geo-select')) {
      this.selectCustomerCountry().finally(() => {
        this.removeAttribute('data-geo-pending')
      })
    }
  }

  setupListeners () {
    this.handleChange = this.handleChange.bind(this)

    this.listeners.add(this.els.select.element, 'change', this.handleChange)
  }

  handleChange (e) {
    this.hasUserSelection = true
    this.showContent(e.target.value)
  }

  showContent (value) {
    this.els.content.elements.forEach((contentEl) => {
      contentEl.setAttribute(
        'aria-expanded',
        contentEl.dataset.title === value,
      )
    })
  }

  async selectCustomerCountry () {
    const selectEl = this.els.select?.element

    if (!selectEl || !window.BAO.geoLocationPromise) return

    try {
      await window.BAO.geoLocationPromise
    } catch (e) {
      return
    }

    const countryCode = window.theme?.customer?.countryCode

    if (!countryCode || this.hasUserSelection) return

    const matchingOption = Array.from(selectEl.options).find(
      (option) => option.dataset.countryCode === countryCode,
    )

    if (!matchingOption) return

    selectEl.value = matchingOption.value
    this.showContent(matchingOption.value)
  }
}

if (!customElements.get('dropdown-toggle')) {
  customElements.define('dropdown-toggle', DropdownToggle)
}
